<template>
  <div style="height: 305px;" class="main-chart">
    <canvas id="myChart" width="800" height="305"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "transaction-chart",

  props: {
    chartData: null,
    graphSelections: null,
  },
  data() {
    return {
      chart: null,
      options: {
        pointRadius: 3,
        pointHoverRadius: 23,

        lineColor: "#4693ce",
        plugins: {
          legend: { display: false },
          tooltip: {
            bodyColor: "#212529",
            backgroundColor: "white",
            cornerRadius: 15,
            displayColors: true,

            callbacks: {
              label: function(tooltipItem) {
                var t =
                  tooltipItem.dataset.label +
                  " : " +
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(tooltipItem.parsed.y);

                return t;
              },
            },

            bodyFont: {
              size: 12,
              family: "'Helvetica', sans-serif",
              color: "#212529",
              weight: "normal",
              style: "normal",
            },
          },
        },
        elements: {
          line: {
            tension: 0.4,
          },
        },
        responsive: true,

        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            grid: { display: true },
            beginAtZero: true,
            borderDash: [2, 4],
            ticks: {
              callback: function(value, index, values) {
                //return values.dataset.borderColor;
                return "$" + value;
              },
              font: {
                family: "'SF Pro', sans-serif",
                color: "#212529",
                weight: "normal",
                style: "normal",
              },
            },
          },
        },

        padding: 0,
        height: "100%",
        fill: false,
        maintainAspectRatio: false,

        hover: {
          mode: true,
        },
      },
      datacollection: null,
    };
  },
  watch: {
    chartData: function(val) {
      this.chart.data = this.fillData();
      this.chart.update();
    },
    graphSelections: function(val) {
      this.chart.data = this.fillData();
      this.chart.update();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  mounted() {
    const ctx = document.getElementById("myChart").getContext("2d");
    this.chart = new Chart(ctx, {
      type: "line",
      data: this.fillData(),
      options: this.options,
    });

    this.fillData();
  },
  methods: {
    fillData() {
      console.log(this.graphSelections);
      console.log(this.chartData);
      var d = {
        labels: [],
        datasets: [],
      };

      if (this.graphSelections.approvedAmount) {
        d.datasets.push({
          label: "Approved",
          fill: false,
          pointBackgroundColor: "#2dce89",
          borderColor: "#c0f0db",
          data: this.chartData.approved.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.voidRefundAmount) {
        d.datasets.push({
          label: "Voided/Refunded",
          fill: false,
          pointBackgroundColor: "#fb6340",
          borderColor: "#fed0c5",
          data: this.chartData.voidRefund.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.declinedAmount) {
        d.datasets.push({
          label: "Declined",
          fill: false,
          pointBackgroundColor: "#f5365c",
          borderColor: "#fcc2ce",
          data: this.chartData.decline.map((e) => e.amount / 100),
        });
      }




      if (this.graphSelections.terminalAmount) {
        d.datasets.push({
          label: "Terminal",
          fill: false,
          pointBackgroundColor: "#1395ba",
          borderColor: "#89cadc",
          data: this.chartData.terminal.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.virtualAmount) {
        d.datasets.push({
          label: "Virtual",
          fill: false,
          pointBackgroundColor: "#0f5b78",
          borderColor: "#87adbb",
          data: this.chartData.virtual.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.paymentPlanAmount) {
        d.datasets.push({
          label: "Payment Plans",
          fill: false,
          pointBackgroundColor: "#d94e1f",
          borderColor: "#eca68f",
          data: this.chartData.paymentPlan.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.membershipAmount) {
        d.datasets.push({
          label: "Memberships",
          fill: false,
          pointBackgroundColor: "#ef8b2c",
          borderColor: "#f7c595",
          data: this.chartData.membership.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.paymentRequestAmount) {
        d.datasets.push({
          label: "Payment Requests",
          fill: false,
          pointBackgroundColor: "#ebc844",
          borderColor: "#f5e3a1",
          data: this.chartData.paymentRequest.map((e) => e.amount / 100),
        });
      }

      if (this.graphSelections.paymentPageAmount) {
        d.datasets.push({
          label: "Payment Page",
          fill: false,
          pointBackgroundColor: "#a2b86c",
          borderColor: "#d0dbb5",
          data: this.chartData.paymentPage.map((e) => e.amount / 100),
        });
      }

      this.chartData.approved.forEach((f) => {
        d.labels.push(f.timeValue);
      });

      return d;
    },
  },
};
</script>
